/*eslint-disable */
<template>
  <b-container fluid style="background-color: #fff">
    <b-row>
      <div class="iq-top-navbar">
        <div class="iq-navbar-custom">
          <nav class="navbar navbar-expand-lg navbar-light p-0">
            <div class="iq-navbar-logo d-flex justify-content-between">
              <img :src="orgData.org_profile_img" class="img-fluid navBarLogo ml-2 mt-3" alt="logo">
            </div>
          </nav>
        </div>
      </div>

      <b-col md="8" lg="8" class="" v-if="operatingsystem == 'web'">
        <iq-card class="p-4 banner-text-left-card">
          <template v-slot:headerTitle v-if="!propOpenedInModal">
            <img :src="orgData.org_cover_img" style="width:100%" />
            <!-- Event Description -->
            <div class="col-12 mt-4">
              <span id="contactUsV1EventDescId" v-html="orgData.org_desc"></span>
            </div><!-- Event Description -->
          </template>
        </iq-card>
      </b-col>

      <b-col md="12" lg="8" class="" v-if="operatingsystem != 'web'">
        <iq-card class="ban_card">
          <template v-slot:headerTitle>
            <img :src="orgData.org_cover_img" style="width:100%" />
          </template>
        </iq-card>
      </b-col>

      <b-col lg="4" style='background-color:#fff'>
        <div class="p-3">
          <h3 class="mb-2">
            <span class="primary-color">{{orgData.org_name}}</span>
          </h3>
          <h3 class="mt-4">
            Sign In
          </h3>
          <p>Don't have an account? <router-link :to="{ path: 'register'}">
            Sign Up
          </router-link></p>
          <div>
            <div id="buttonDiv" style="width: 100%;">
            </div>
          </div>
          <ValidationObserver ref="loginForm">
            <form class="mt-4" @submit.prevent="login">
              <div class="form-group">
                <label for="validationTooltipEmail">Email address</label>
                <ValidationProvider name="Email" rules="required|email" v-slot="{ errors }">
                  <input
                    v-model="userEmail"
                    type="email"
                    class="form-control mb-0"
                    id="validationTooltipEmail"
                    placeholder="Email"
                    name="Email"
                    @blur="userVerify"
                  >
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="form-group" v-show="showPasswordField">
                <label for="exampleInputPassword1">Password</label>
                <input v-model="userPassword" :disabled="disablePasswordField" type="password" class="form-control mb-0" id="exampleInputPassword1" placeholder="Password">
              </div>

              <div class="d-inline-block w-100">
                <div class="custom-checkbox d-inline-block mt-2 pt-1">
                  <router-link :to="{ path: '/forgotPassword',params:{'email': userEmail} }">
                    Forgot password?
                  </router-link>
                </div>

                <button v-if="showSubmitBtn" type="submit" :data-sitekey="YOUR_SITE_KEY" data-callback='recaptchaOnClick' data-action='submit' id="g-recaptcha" class="g-recaptcha btn btn-primary float-right" @click="login">
                  Sign In
                </button>
              </div>

              <div v-if="DOMAIN_NAME.includes('gide.ai')">
                <!-- Google & Apple Login Login -->
                <div id="or">
                  OR
                </div>

                <div class="signGoogle">
                  <div class="btn btn-google" type="button" @click="login_google">
                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="32px" height="32px"
                        viewBox="0 0 48 48"
                        class="abcRioButtonSvg mr-2" style="margin-top: 1px;">
                      <g>
                        <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path>
                      </g>
                    </svg>
                    <span>Sign in with Google</span>
                  </div>
                </div>

                <!-- https://developer.apple.com/design/human-interface-guidelines/technologies/sign-in-with-apple/ -->
                <!-- https://developer.apple.com/documentation/sign_in_with_apple/displaying_sign_in_with_apple_buttons_on_the_web -->
                <!-- Google & Apple Login Login -->
                <div class="mt-3">
                  <div class="" v-if="apple_signin_usePopup">
                    <div id="appleid-signin" class="signin-button" data-color="white" data-border="true" data-width="207" data-height="49" data-type="sign in"></div>
                  </div>
                  <div class="ml-2" v-else>
                    <div id="appleid-signin1" class="signin-button" data-color="white" data-border="true" data-width="207" data-height="49" data-type="sign in" @click="login_apple_redirect"></div>
                  </div>
                </div>

                <div v-if="auth_loader" class="text-center mt-3">
                  <b-spinner variant="primary" label="Spinning"></b-spinner>
                </div>
              </div>

              <div class="sign-info">
                <span class="dark-color d-inline-block line-height-2">Are you a school, university, edtech or any other organisation ? <router-link :to="{ path: '/contactUsV2?f=1&sf=1'}">Contact Us</router-link></span>
                <span class="dark-color d-inline-block mt-4" style="line-height: 1.2;">
                  <a href="mailto:support@gide.ai">Need Help !</a><br>
                  <small>[Support timings between 11am to 5pm]</small><br>
                </span>
                <div>
                  <ul class="iq-social-media mt-2">
                    <li>
                      <a href="https://www.facebook.com/highschoolmomsgroup" target="_blank"><i class="ri-facebook-box-line"></i></a>
                    </li>
                    <li>
                      <a href="https://twitter.com/hsminace" target="_blank"><i class="ri-twitter-line"></i></a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/highschoolmoms" target="_blank"><i class="ri-instagram-line"></i></a>
                    </li>
                    <li>
                      <a href="https://www.linkedin.com/company/highschoolmoms/" target="_blank"><i class="ri-linkedin-line"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </form>
          </ValidationObserver>

          <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
            <div v-html="toastMsg">
            </div>
          </b-toast>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script src="https://accounts.google.com/gsi/client" async defer></script>

<script>
/*eslint-disable */
import { User } from '../FackApi/api/user.js'
import AutoLogin from '../Utils/autoLogin.js'
import { ValidationProvider } from 'vee-validate'
import { Organisations } from "../FackApi/api/organisation.js"
import { reCaptcha } from "../Utils/reCaptcha.js"

export default {
  name: 'Login',
  components: {
    ValidationProvider
  },
  data: () => ({
    YOUR_SITE_KEY: process.env.VUE_APP_GOOGLE_RECAPTCHA3_KEY,
    showSubmitBtn: false,
    apple_signin_usePopup: true,
    apple_redirectURI_IOS : location.protocol+'//'+location.hostname+(location.port ? ':'+location.port : '')+'/login',
    apple_redirectURI_OTHER : location.protocol+'//'+location.hostname+(location.port ? ':'+location.port : '')+'/apple_signin_webhook',
    //apple_redirectURI_OTHER : location.protocol+'//'+location.hostname+':3000/apple_signin_webhook', //for localtesting Create a build and start the server in https mode
    apple_login_url: "https://appleid.apple.com/auth/authorize?client_id=com.gide.io.signin&redirect_uri={apple_redirectURI_OTHER}&response_type=code%20id_token&state=apple_sign_in&scope=name%20email&response_mode=form_post&frame_id=53783245-1e71-43fc-99ce-e434c0792331&m=11&v=1.5.2",
    device: "web",
    showToast: false,
    toastMsg: null,
    toastVariant: 'default',
    toastTitle: 'User',
    userEmail: '',
    userPassword: '',
    showPasswordField: true,
    userVerifyRespData: null,
    keepMeLogin: true,
    // only needed if you want to render the button with the google ui
    renderParams: {
      width: 250,
      height: 50,
      longtitle: true
    },
    auth_loader: false,
    operatingsystem: window.__DEVICE_OS__,
    orgId: null,
    orgData: {
      id: 54238,
      org_id: "GIDE_ORG_1",
      user_id: "1",
      acc_id: "1",
      org_name: "GIDE.AI",
      type: "ORG",
      org_desc: `<h1><strong style="color: rgb(226, 38, 44);">GIDE.AI</strong><strong>: </strong>Your Gateway to Scholarships and Career Success</h1><p><strong style="color: rgb(230, 0, 0);">Brought to you by Asia's largest Student and Parent community - High School Moms (HSM)</strong></p><p>Access futuristic career assessment, profile building, test preparation, great scholarships, and career guidance all in one integrated experience.</p><p><br></p>`,
      org_website_email: null,
      org_admin_email: "admin@gide.ai",
      org_admision_email: "admissions@gide.ai",
      org_admission_requirement: null,
      org_top_alums: null,
      org_major_industries_around: null,
      org_clubs: null,
      org_college_type: null,
      org_city: null,
      org_country: null,
      org_founding_year: null,
      org_application_deadline: null,
      org_intake_count: null,
      org_intake_type: null,
      org_currency: null,
      org_avg_tuition_min: null,
      org_avg_tuition_max: null,
      org_scholarship_min: null,
      org_scholarship_max: null,
      org_tnc: 0,
      created_on: "2023-11-22T23:26:47.000Z",
      deleted: 0,
      country_id: null,
      org_profile_img: "https://web.gide.ai/img/GideWhiteNRed.2533ee45.jpeg",
      org_cover_img: "https://gide-assets.s3.amazonaws.com/GIDECover.White.png",
      org_state: null,
      org_uid: "",
      org_domain: "web.gide.ai",
      org_domain_is_validated: 99,
      country_name: null,
      currency_name: null,
      currency_code: null
    },
    propOpenedInModal: false,
    DOMAIN_NAME: window.location.hostname.toLowerCase()
  }),
  computed: {
    sourceData () {
      return this.$store.getters["SourceTracker/getUserSource"]
    },
    saasOrgData () {
      return this.$store.getters["SaasOrgData/getSaasOrgData"]
    },
    disablePasswordField () {
      return !!(this.userVerifyRespData && !this.userVerifyRespData.user_password && this.userVerifyRespData.user_is_profile_complete == 1)
    }
  },
  async mounted () {
    await this.getOrgDetails()

    // this.initiateGoogleLoginView()
    window.addEventListener("flutterInAppWebViewPlatformReady", function (event) {
      console.log("flutterInAppWebViewPlatformReady NOW")
    })

    if(navigator.userAgent.toLowerCase().includes("iphone")
      || navigator.userAgent.toLowerCase().includes("ipod")
      || navigator.userAgent.toLowerCase().includes("ipad")
    ){
      this.apple_signin_usePopup = true
    }
    else if(navigator.userAgent.toLowerCase().includes("android")){
      this.apple_signin_usePopup = false
    }
    else {
      this.apple_signin_usePopup = false
    }

    //INIT APPLE LOGIN
    this.apple_login_url = this.apple_login_url.replace("{apple_redirectURI_OTHER}", encodeURIComponent(this.apple_redirectURI_OTHER))
    this.login_apple_init()

    //Callback Handler Called after Apple Authentication with page callback. Not using Popoup Box
    if(this.$route.query.f == "apple_signin_webhook"){
      console.info("apple_signin_webhook Check", this.$route.query)
      let code = this.$route.query.code
      let id_token = this.$route.query.id_token
      let state = this.$route.query.state
      let userInfo = this.$route.query.user ? this.$route.query.user : null

      this.update_current_url("","", true)

      if(!code || !id_token || !state){
        //If any if them are null or undefined then show error
        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "There was a problem while Apple sign-in. Please try again"
        return
      }

      this.auth_loader = true

      console.log("apple_signin_webhook", code, id_token, state, userInfo)
      this.apple_signin_webhook(code, id_token, state, userInfo)
    }

    let context = this
    if (window.grecaptcha) {
      // Recaptcha Already verified
      this.showSubmitBtn = true
      return
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.render("g-recaptcha", {
        sitekey: this.YOUR_SITE_KEY,
        size: "invisible", // 'compact' or 'invisible' are also available
        callback: context.recaptchaOnClick // This function is called on Submiting the form.
      })
    })
  },
  methods: {
    /**
     * Validate Captcha and enable SignIn Button
     */
    async recaptchaOnClick (captchaToken) {
      // Handle the response from the reCAPTCHA server
      // Can be verified from the server side via Custome API
      await reCaptcha.createAssessment(this, this.YOUR_SITE_KEY, captchaToken)
      this.showSubmitBtn = true
    },
    /**
     * getOrgDetails
     */
    async getOrgDetails () {
      try {
        // Do not get the org_details if running on localhost, for localdns we have to set the org_domain in DB
        if (process.env.VUE_APP_ENV == "local") {
          this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)
          return
        }

        const orgDomain = window.location.hostname
        const orgDetails = await Organisations.organisationView(this, this.orgId, orgDomain)
        if (!orgDetails.resp_status) {
          // set the details of GIDE_ORG_1 as default
          this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)
          return
        }

        this.orgData = orgDetails.resp_data.data
        // set the org data in local storage for saving in user table
        this.$store.dispatch("SaasOrgData/setSaasOrgData", this.orgData)

        // set the source for the user
        let source = this.orgData.org_uid
        if (this.sourceData) {
          source = this.orgData.org_uid + "_" + this.sourceData
        }

        this.$store.dispatch("SourceTracker/setCodeAction", source)
      }
      catch (err) {
        console.error("Exception in getOrgDetails and err: ", err)
      }
    },
    /**
     * login_google
     * Login via Google
     * https://www.npmjs.com/package/vue-google-oauth2
     */
    async login_google() {
      this.auth_loader = true;

      const googleUser = await this.$gAuth.signIn()
      this.isSignIn = this.$gAuth.isAuthorized
      let user = googleUser.getBasicProfile()
      let response = googleUser.getAuthResponse()

      if (this.isSignIn) {
        let userObj = {
          user_name: user.getName(),
          user_id: googleUser.getId(),
          user_email: user.getEmail(),
          mobile_no: user.phoneNumber,
          user_image: user.getImageUrl(),
          is_verified: false,
          email_verified:true,
          token: response.id_token
        }

        AutoLogin.autoLogin(this, userObj, 'google')
        this.auth_loader = false
      }
    },
    /**
     * login
     * This method checks which method of login is being used by the user
     */
    async login () {
      let valid = await this.$refs.loginForm.validate()
      if (!valid) {
        return
      }

      if (!this.showPasswordField) {
        await this.userVerify()
        return
      }

      if (this.userEmail !== null && this.userEmail !== '') {
        // Password field is visible to the user
        if (this.showPasswordField) {
          // This means user exists in the database
          await this.userLoginEmail()
        }
      }
    },
    /**
     * userLoginEmail
     */
    async userLoginEmail () {
      let userObj = {
        'user_email': this.userEmail,
        'user_password': this.userPassword,
        'keep_me_logged_in': this.keepMeLogin
      }
      await AutoLogin.autoLogin(this, userObj, 'email')
    },
    /**
     * userVerify
     */
    async userVerify () {
      if (!this.userEmail) {
        return
      }

      let userObj = {
        "user_email": this.userEmail
      }

      let userProfileData = {
        user_email: this.userEmail
      }

      let redirect_to = ''
      this.auth_loader = true
      let userVerifyResp = await User.userVerify(this, userObj)
      this.auth_loader = false
      this.userVerifyRespData = (userVerifyResp && userVerifyResp.resp_status) ? userVerifyResp.resp_data : null

      if (userVerifyResp && userVerifyResp.resp_code == "ERR_USER_DELETED") {
        this.showToast = true
        this.toastVariant = "warning"
        this.toastMsg = userVerifyResp.resp_msg
        return
      }
      else if (userVerifyResp && !userVerifyResp.resp_status) {
        // New User - Check if Mailbox Works or not
        if (userVerifyResp.resp_data && userVerifyResp.resp_data) {
          this.showToast = true
          this.toastVariant = "warning"
          this.toastMsg = userVerifyResp.resp_data

          /*
          setTimeout(() => {
            // If user not found than set basic profile details and redirect to registration page
            redirect_to = '/register'
            this.$router.push(redirect_to)
          }, 3000)
          */
        }
        else if (userVerifyResp.resp_code == "NEW_USER_MAILBOX_IS_VALID") {
          console.log("NEW_USER_MAILBOX_IS_VALID")
        }
        else {
          redirect_to = '/register'
        }
      }
      else if (userVerifyResp.resp_data.user_password) {
        this.showPasswordField = true
      }
      else if (!userVerifyResp.resp_data.user_password && userVerifyResp.resp_data.user_is_profile_complete == 1) {
        // if the profile is already complete but the user has no
        // password show the toast message to set the password

        userProfileData = userVerifyResp.resp_data
        userProfileData.user_email = this.userEmail

        this.showToast = true
        this.toastVariant = "warning"
        this.toastMsg = "You haven't set a password yet. Click 'Forgot Password?' to create one."

        setTimeout(() => {
          this.showToast = false
        }, 5000)
      }
      else if (!userVerifyResp.resp_data.user_password) {
        userProfileData = userVerifyResp.resp_data
        userProfileData.user_email = this.userEmail

        if (!userVerifyResp.resp_data.user_email_verified) {
          await this.userActivationEmail()
        }

        redirect_to = '/activate'
      }
      else if (!userVerifyResp.resp_data.user_is_profile_complete || userVerifyResp.resp_data.user_is_profile_complete !== 1){
        userProfileData = userVerifyResp.resp_data
        userProfileData.user_email = this.userEmail
        redirect_to = '/quick-profile'
      }

      await this.$store.dispatch('User/setUserProfileAction', userProfileData)
      if (redirect_to) {
        await this.$router.push(redirect_to)
      }
    },
    /**
     * login_apple_init
     * Login via apple
     * https://developer.apple.com/documentation/sign_in_with_apple/sign_in_with_apple_js/configuring_your_webpage_for_sign_in_with_apple
     */
    async login_apple_init() {
      /*
       * login_apple_redirect Check is only needed for APPLE LOGIN POPUP FAILED, SO LOGIN VIA REDIRECT
       * If this.$route.query.f != "login_apple_redirect" then login via popup else redirect
       */
      console.log("APPLE-LOGIN-1 login_apple_init => ",navigator.userAgent.toLowerCase())

      //Used to display the Apple login button specific to Android. Set the IOS Button to display: none
      if(
        (navigator.userAgent.toLowerCase().indexOf("iphone") > -1
        || navigator.userAgent.toLowerCase().indexOf("ipad") > -1
        )
        && this.$route.query.f != "login_apple_redirect"
      ){
        console.log("APPLE-LOGIN-2 login_apple_init => iphone or ipad", process.env.VUE_APP_APPLE_CLIENT_ID)

        //For IOS devices enable the IOS orginal button and disbale other and apple signin with popup
        this.apple_signin_usePopup = true
      }
      else{
        console.log("APPLE-LOGIN-2 login_apple_init => other", process.env.VUE_APP_APPLE_CLIENT_ID)

        //For Other devices lik android disbale the IOS orginal button and apple signin with redirect
        this.apple_signin_usePopup = false
      }

      window.AppleID.auth.init({
        clientId : process.env.VUE_APP_APPLE_CLIENT_ID,
        scope : 'name email',
        redirectURI : this.apple_redirectURI_IOS,
        state : 'apple_sign_in',
        usePopup : this.apple_signin_usePopup //false for Android/Web/mWeb and true for IOS
      })

      //Listen for authorization success
      document.addEventListener('AppleIDSignInOnSuccess', async (data) => {
        this.auth_loader = true

        console.log("APPLE-LOGIN-3 AppleIDSignInOnSuccess =>", data)

        let idtoken = data.detail.authorization.id_token
        let code = data.detail.authorization.code
        let token_parse_data = JSON.parse(atob(idtoken.split('.')[1]))
        console.log("APPLE:token_parse_data-1", token_parse_data)

        let userObj = {
          user_name: '',
          user_id: '',
          user_email: '',
          mobile_no: '',
          image: '',
          is_verified: false,
          email_verified: true,
          code: code,
          token: idtoken,
          redirectURI : this.apple_redirectURI_IOS,
        }

        if(data.detail.user){
          let user = data.detail.user
          let name = (user.name) ? user.name : {}
          let first_name = (name.firstName) ? name.firstName : ''
          let last_name = (name.lastName) ? name.lastName : ''

          userObj.user_name = first_name +' '+ last_name
          userObj.user_email = user.email
        }
        else{
          userObj.user_email = token_parse_data.email
        }

        AutoLogin.autoLogin(this, userObj, 'apple')
      })

      //Listen for authorization failures
      document.addEventListener('AppleIDSignInOnFailure', (error) => {
        this.auth_loader = false
        console.log("APPLE-LOGIN-3 AppleIDSignInOnFailure =>", error.detail.error, error)

        let error_msg = error.detail.error
        if(error_msg == "popup_closed_by_user"){
          error_msg = "You closed the Apple signin popup"
        }
        else{
          error_msg = "Looks like your device is not linked to this Apple ID or you have not signed into your iCloud Account. Kindly sign-into you iCloud account before using the option"

          /**
           * APPLE LOGIN POPUP FAILED, SO LOGIN VIA REDIRECT
           * Enable this When the below can be opened in safari browser of IOS Device. Currently it the Apple Login
           * Box open in the App itself and after validation, continue is not posting on the redirect URL. As a result the login
           * via redirect is not working on IOS.
           */
          if(window.flutter_inappwebview){
            console.log("APPLE-LOGIN-3: On Mobile App APPLE LOGIN POPUP FAILED, SO LOGIN VIA REDIRECT: window.flutter_inappwebview", {data: {url: this.apple_login_url}});
            window.flutter_inappwebview.callHandler('launchInBrowser', {data: {url: this.apple_login_url}})
          }
        }
      })

      /*
       * APPLE LOGIN POPUP FAILED, SO LOGIN VIA REDIRECT
       */
      if(this.$route.query.f == "login_apple_redirect"){
        this.update_current_url("","", true)
        this.login_apple_redirect()
      }
    },
    /**
     * login_apple_redirect
     * Login via apple using redirect instead of popup
     *
     */
    login_apple_redirect() {
      /* If you are testing via mwebdevx then u have test on port 3000. Do the following:-
       *
       * vi server.js
       * is_HTTPs = true //Set to true. After testing set to false
       * npm run build
       * nodemon server.js
       */
      try {
        this.auth_loader = true

        const data = window.AppleID.auth.signIn({
          clientId : process.env.VUE_APP_APPLE_CLIENT_ID,
          scope : 'name email',
          redirectURI : this.apple_redirectURI_OTHER,
          state : 'apple_sign_in',
          usePopup : false //For mWeb use False for Web use true
        })

        console.log("login_apple_redirect data = ", data)

        this.auth_loader = false
      }
      catch ( error ) {
        console.error("login_apple_redirect error = ", error)
        this.auth_loader = false

        this.showToast = true
        this.toastVariant = "danger"
        this.toastMsg = "Apple signin error"
        return
      }
    },
    /**
     * apple_signin_webhook
     * We are using Apple Login without Popup. So when Login is successful, apple page, does a post on the callback/redirectURL.
     * Since Vuejs cannot handle POST request, the request is actually handled by server.js
     * The POST params are extracted from the body and converted to GET and passed on to the login page.
     * Ex:- https://mwebdevx.meshchat.co:4444/login?f=apple_signin_webhook&code=c6ea3fdeae4e64fba987aecdb44c13e90.0.nvtv.lL3T8a-myfXhCO4DBqbzeA&id_token=eyJraWQiOiI4NkQ4OEtmIiwiYWxnIjoiUlMyNTYifQ.eyJpc3MiOiJodHRwczovL2FwcGxlaWQuYXBwbGUuY29tIiwiYXVkIjoiY29tLm1lc2hjaGF0LmNvLnNpZ25pbiIsImV4cCI6MTU5MjUwOTIxOSwiaWF0IjoxNTkyNTA4NjE5LCJzdWIiOiIwMDA1MzUuNDlhODQ3MzYzYmQyNGFiYWJiNWI0MzFiYjNkMjJhYTQuMTc0NiIsImNfaGFzaCI6ImYxcVphWUJYVUpWZkx5T183clo2QWciLCJlbWFpbCI6ImR6NXZ5ZDM1Z3VAcHJpdmF0ZXJlbGF5LmFwcGxlaWQuY29tIiwiZW1haWxfdmVyaWZpZWQiOiJ0cnVlIiwiaXNfcHJpdmF0ZV9lbWFpbCI6InRydWUiLCJhdXRoX3RpbWUiOjE1OTI1MDg2MTksIm5vbmNlX3N1cHBvcnRlZCI6dHJ1ZX0.bu1VWPgetg4GmpVMo6cgkE2pUQ4gxGjYOygF7hSz-5M3dfEwBvUJKJxSrm40vSfInB6gOXCFQW_6uqR3oyFeSO4EbCl0vvULzmkWJmzMQMVV8oN7UK2TUNb5rmcnGsqpbPpEzZJNI8q-Xi5ePalkE4m84Rq1GkwQai0AJWwyUsIJpRuMWp1kwYrc1Ru2Y3xeqe2AcckLH6bacnpTEhLG_pmh4wlZYXjXEbHMguXJUALAYbFSC87sU2Zfmec
     *
     */
    apple_signin_webhook(code, token, state, user_info=null){
      let token_parse_data = JSON.parse(atob(token.split('.')[1]))
      user_info = JSON.parse(user_info)
      user_info = user_info && user_info.name ? user_info.name : null
      console.log("APPLE:token_parse_data-2", token_parse_data, user_info)

      let userObj = {
        user_name: user_info ? user_info.firstName + " " + user_info.lastName : '',
        user_id: '',
        user_email: '',
        mobile_no: '',
        image: '',
        is_verified: false,
        email_verified:true,
        token: token,
        code:code,
        redirectURI : this.apple_redirectURI_OTHER,
        state:state
      }

      userObj.user_email = token_parse_data.email

      AutoLogin.autoLogin(this, userObj, 'apple')
    },
    /**
     * userActivationEmail
     */
    async userActivationEmail () {
      await User.userActivationEmail(this, this.userEmail)
    },
    /**
    * update_current_url - Update the Visible URL on Browser
    *
    */
    update_current_url(url_key, url_val=null, remove_query_string=true){
      //Update the Visible URL on Browser
      var curr_url = new URL(location.href);

      if(remove_query_string){
        //Remove the entire query string
        curr_url =  window.location.href.split("?")[0];
      }
      else{
        //Remove the selected value from query string
        var params = new URLSearchParams(curr_url.searchParams.toString());
        params = params.toString();

        if(params.indexOf(url_key) != -1){
          //Found the Param. Now Remove it
          curr_url.searchParams.delete(url_key)
        }

        if(url_val != null){
          if(curr_url.toString().indexOf("?") != -1){
            //If Found
            curr_url = curr_url + "&" + url_key + "=" + url_val
          }
          else{
            curr_url = curr_url + "?" + url_key + "=" + url_val
          }
        }
      }

      if (history.pushState) {
        window.history.pushState({path:curr_url},'',curr_url)
      }
    },
  },
  watch:{
  }
}
</script>

<style>
  @import url("../assets/css/custom.css");
  @import url("../assets/css/PriceSlider.css");
  .launchpad_text{
    height: 0px;
    position: relative;
    top: -90px;
    line-height: 1.2;
  }
   @media screen and (min-width: 320px) and (max-width: 575px) {
    .launchpad_text{
      position: unset;
      height: auto;
      line-height: 1.2;
    }
  }
  @media screen and (min-width: 576px) and (max-width: 991px) {
    .launchpad_text{
      position: relative;
      top: auto;
      height: auto;
      line-height: 1.2;
    }
  }
  div.iq-top-navbar{
    box-shadow:0px 0px 5px 0px rgba(44, 101, 144, 0.1) !important;
  }
  .signin-button {
    margin: auto;
    display: block;
    width: max-content;
  }
  .signin-button div:first-child{
    left: -3px;
  }
  .signGoogle {
    font-size: 15px;
    text-align: center;
  }
  .btn-google {
    /* color: var(--iq-primary); */
    color: black;
    background: #fff;
    /* border-color: var(--iq-primary); */
    border-color: unset;
    font-weight:600;
  }
  #or {
    position: relative;
    height: 50px;
    background: #fff;
    line-height: 50px;
    text-align: center;
  }
  #or:after, #or:before {
    position: absolute;
    width: 40%;
    height: 2px;
    top: 24px;
    background-color: #aaa;
    content: "";
  }
  #or:before {
    left: 0;
  }
  #or:after {
    right: 0;
  }
</style>
